exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cs-navigation {\n  font-family: PingFangSC-Regular;\n  color: #999999;\n  letter-spacing: -0.07px;\n  line-height: 14px;\n  padding: 12px 0 13px 0;\n}\n.cs-navigation .navigation-list {\n  display: inline-block;\n}\n.cs-navigation .navigation-list span:hover {\n  cursor: pointer;\n}\n.cs-navigation .navigation-list .anticon-right {\n  padding: 0 3px;\n}\n.cs-navigation .navigation-list .navigation-now {\n  color: #151515;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/less-loader/dist/cjs.js?{"modifyVars":{"@primary-color":"#1DA57A"}}!./src/components/public/navigation/style/index.less
// module id = 1292
// module chunks = 0